<template>
  <el-config-provider :locale="locale">
    <router-view />
    <!-- AI 智能助手悬浮按钮 — 仅在 project 页面显示 -->
    <div v-if="isProjectPage" class="ai-float-btn" @click="goToAI">
      <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
        <path d="M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z"/>
      </svg>
      <span class="ai-btn-text">AI 助手</span>
    </div>
  </el-config-provider>
</template>

<script setup>
import { ref, computed } from "vue";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import en from "element-plus/lib/locale/lang/en";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

// 仅在 project 相关页面显示 AI 助手按钮
const isProjectPage = computed(() => route.path.includes('/project'));

const goToAI = () => {
  router.push('/mecs/project/analysis');
};

// ElementPlus全局中文显示 localStorage.getItem(VUE_ADMIN_LANG_LOCALE) =="zh-CN"
const localeObj = {
  ...zhCn,
  el: {
    ...zhCn.el,
    colorpicker: { confirm: '确认', clear: '清空' },
    messagebox: { title: '提示', confirm: '确认', cancel: '取消', error: '输入的数据不合法!' },
  }
};

const locale = ref(localeObj);

// 解决el-table 调整窗口报错
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};
</script>

<style lang="scss">
@import url(../public/css/iconfont.css);
@import url(../public/css/index.css);
html,
body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}
#app {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  height: 100%;
  padding: 0;
  margin: 0;
  // VR样式
  body div canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

// 自定义进度条颜色
#nprogress .bar {
  background: var(--color-primary) !important;
}

// AI 智能助手悬浮按钮
.ai-float-btn {
  position: fixed !important;
  right: 24px !important;
  bottom: 80px !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #409EFF, #337ecc);
  color: #fff;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10000 !important;
  opacity: 0.15;
  &:hover {
    opacity: 1;
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.6);
  }
  .ai-btn-text {
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap;
    color: #fff;
  }
}
</style>
